export const en = {
    allSpecialists: 'All experts',
    becomeSpecialist: 'Become an expert',
    customer: 'Client',
    myCustomers: 'My clients',
    myOwnCampaigns: 'My campaigns',
    myProfile: 'My profile',
    mySpecialist: 'My expert',
    specialistsOfYandexDirect: 'experts in Yandex.Direct setup'
};
